import { Component, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NgxSmartModalService } from "ngx-smart-modal";
import { Subject } from "rxjs";
import { LanguageService } from "src/app/services/language.service";

export const LANG_MODAL_ID = "LANG_MODAL";
export const USER_LANG = "LANGUAGE";

@Component({
  selector: "app-lang-modal",
  templateUrl: "./lang-modal.component.html",
  styleUrls: ["./lang-modal.component.scss"],
})
export class LangModalComponent implements OnInit, OnDestroy {
  private readonly onDestroy$ = new Subject<void>();

  constructor(
    private _translate: TranslateService,
    private _modal: NgxSmartModalService,
    private _lang: LanguageService
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  changeLang(lang: "en" | "es") {
    this._lang.changeLanguage(lang);
    this.close();
    localStorage.setItem(USER_LANG, lang);
  }

  // changeLang(lang: "en" | "es") {
  //   this._translate.use(lang);
  //   this.close();
  // }

  close() {
    this._modal.get(LANG_MODAL_ID).close();
    this._modal.removeModal(LANG_MODAL_ID);
  }
}
